import { useState, useCallback } from 'react'

import { useSpring, SpringValue } from 'react-spring'

interface Hooks {
  isHovered: boolean
  setHover: () => void
  resetHover: () => void
  bgSpring: Record<string, SpringValue>
}

export function useHooks(): Hooks {
  const [isHovered, toggleHovered] = useState(false)

  const setHover = useCallback(() => {
    toggleHovered(true)
  }, [])

  const resetHover = useCallback(() => {
    toggleHovered(false)
  }, [])

  const bgSpring = useSpring({
    from: { transform: 'translate3d(0px, 0px, -5px)' },
    to: {
      transform: isHovered
        ? 'translate3d(8px, 8px, -5px)'
        : 'translate3d(0px, 0px, -5px)',
    },
    config: {
      mass: 1,
      tension: 200,
      friction: 30,
    },
  })

  return {
    isHovered,
    setHover,
    resetHover,
    bgSpring,
  }
}
